import React from 'react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div style={{ marginBottom: '48px', textAlign: 'center' }}>
          <h2 className="hero-medium" style={{ marginBottom: '16px' }}>Cherished by Discerning Clients</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Hear from those who appreciate exceptional quality
          </p>
        </div>

        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '32px'
        }}>
          {testimonials.map(testimonial => (
            <div 
              key={testimonial.id}
              style={{
                background: 'var(--bg-primary)',
                padding: '32px',
                transition: 'transform 0.2s ease'
              }}
              className="hover-lift"
            >
              <div style={{ marginBottom: '16px' }}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} style={{ color: 'var(--text-primary)', fontSize: '16px' }}>★</span>
                ))}
              </div>
              <p className="body-regular" style={{ marginBottom: '24px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                "{testimonial.content}"
              </p>
              <div>
                <p className="body-regular" style={{ fontWeight: 700, marginBottom: '4px' }}>
                  {testimonial.name}
                </p>
                <p className="body-small" style={{ color: 'var(--text-light)' }}>
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
